import { useMarketStore } from '@/stores/marketStore';

export const SOURCE_UNCONFIRMED = 'Source confirmation unavailable — order not sent. Wait for this market to recover.';

/** Re-read at submission, not from a VenueBook captured by an earlier render.
 * Only known markets on evidence-enabled feeds participate. Legacy/manual
 * unknown instruments retain their existing contract. Cancels and decreases
 * do not need price authority and never call this guard.
 */
export function sourceConfirmationError(input: { ticker?: string; tokenId?: string }): string | null {
  const store = useMarketStore.getState();
  const ticker = input.ticker ?? (input.tokenId ? store.getTickerByTokenId(input.tokenId) : null);
  return ticker && store.getSourceValidity(ticker) === 'unconfirmed' ? SOURCE_UNCONFIRMED : null;
}
export function assertSourceConfirmed(input: { ticker?: string; tokenId?: string }): void {
  const error = sourceConfirmationError(input);
  if (error) throw new Error(error);
}
